import { VuexModule, Module, Action } from "vuex-module-decorators";
import LoggingHistoryConfigurationsClient from "Clients/logging-history-configurations-client";
import { LoggingHistoryConfig } from "@/types/loggingHistoryConfig";


@Module({ namespaced: true, name: "DataHistory" })
class DataHistory extends VuexModule {

  @Action({ rawError: true })
  public async fetchConfigByVesselId(vesselId: number): Promise<LoggingHistoryConfig | undefined> {
    try {
      return await LoggingHistoryConfigurationsClient.getByVesselId(vesselId);
    } catch (error) {
      console.warn(error);
    }
  }

  @Action({ rawError: true })
  public async updateConfig(config: LoggingHistoryConfig): Promise<void> {
    try {
      await LoggingHistoryConfigurationsClient.update(config);
    } catch (error) {
      console.warn(error);
    }
  }

}

export default DataHistory;
